import React, { Component } from 'react'
import Orders from './Orders'
import { get, isEmpty, pick } from 'lodash'
import { message } from 'antd'
import OrdersApi from '../../../api/Sales/Orders'
import { strVal } from '../../../modules/Utils'

class OrdersCont extends Component {
  state = {
    list: [],
    cached: [],
    billLines: [],
    selection: [],
    fetching: true,
    contract: this.props.contract,
  }
  api = new OrdersApi()

  componentDidMount() {
    this.fetch()
  }

  fetch = async () => {
    try {
      this.setState({
        fetching: true,
      })
      const cached = await this.api.list(this.props.contract)
      let list = cached

      if (!isEmpty(this.state.company)) list = cached.filter((i) => i.company._id === this.state.company)
      this.setState({
        fetching: false,
        list,
        cached,
      })
    } catch (e) {
      message.error(e.errorMessage)
      this.setState({ fetching: false })
    }
  }
  fetchOrderLines = async () => {
    try {
      this.setState({
        fetchingOrderLines: true,
      })
      const cachedOrderLines = await this.api.bookings(this.props.contract)
      let orderLinesList = cachedOrderLines
      if (!isEmpty(this.state.company))
        orderLinesList = cachedOrderLines.filter((i) => i.order.company._id === this.state.company)
      this.setState({
        fetchingOrderLines: false,
        orderLinesList,
        cachedOrderLines,
      })
    } catch (e) {
      message.error(e.errorMessage)
      this.setState({ fetchingOrderLines: false })
    }
  }
  filterCompany = (_id) => {
    this.setState((prevState, props) => ({
      list: _id ? prevState.cached.filter((i) => i.company._id === _id) : prevState.cached,
    }))
  }
  onChangeCompany = (company) => {
    this.filterCompany(company)
    this.setState({
      company,
    })
  }
  toggleSelection = (key) => {
    let selection = [...this.state.selection]
    const keyIndex = selection.indexOf(key)
    if (keyIndex >= 0) {
      selection = [...selection.slice(0, keyIndex), ...selection.slice(keyIndex + 1)]
    } else {
      selection.push(key)
    }
    this.setState({ selection })
  }
  isSelected = (key) => {
    return this.state.selection.includes(key)
  }
  tableRef = React.createRef()
  toggleAll = () => {
    const selectAll = !this.state.selectAll
    const selection = []
    if (selectAll) {
      const wrappedInstance = this.tableRef.current
      const currentRecords = wrappedInstance.getResolvedState().sortedData
      currentRecords.forEach((item) => {
        selection.push(item._original._id)
      })
    }
    this.setState({ selectAll, selection })
  }

  invoiceComboOrders = async () => {
    const selection = this.state.selection.map((t) => this.state.list.find((i) => i._id === t))
    if (
      !selection.reduce((prv, current) => (strVal(prv, 'contract._id') === strVal(current, 'contract._id') ? prv : NaN))
    ) {
      message.error('Not the same Contract')
      return
    }
    if (!selection.reduce((prv, current) => (get(prv, 'company._id') === get(current, 'company._id') ? prv : NaN))) {
      message.error('Not the same company')
      return
    }
    if (selection.find((s) => !['Confirmed', 'Delivered'].includes(s.status))) {
      message.error(`Can't invoice non confirmed invoices`)
      return
    }
    try {
      this.setState({
        fetchingLines: true,
      })

      const comboLines = await this.api.lines.combo(this.state.selection)
      this.setState({
        billLines: comboLines,
        visibleInvoice: true,
        invoice: {},
        fetchingLines: false,
      })
    } catch (e) {
      this.setState({
        fetchingLines: false,
      })
    }
  }
  onCancelInvoice = () => {
    this.setState({
      visibleInvoice: false,
    })
    this.fetch()
  }

  render() {
    return (
      <Orders
        {...this.state}
        {...pick(this, [
          'fetch',
          'fetchOrderLines',
          'fetching',
          'filterCompany',
          'invoiceComboOrders',
          'onChangeCompany',
          'onCancelInvoice',
          'toggleSelection',
          'isSelected',
          'toggleAll',
          'tableRef',
        ])}
      />
    )
  }
}

OrdersCont.propTypes = {}
OrdersCont.defaultProps = {}

export default OrdersCont
